<template>
<div>
    <vs-tabs alignment="fixed" v-model="activeTab" >
        <vs-tab label="Log Hours" icon-pack="feather" icon="icon-calendar">
            <vx-card>
            <vs-table stripe pagination :max-items="10" search :data="getAllLogHours" >

                <template slot="thead">
                    <vs-th>Code</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th>Basic Pay</vs-th>
                    <vs-th>HoursWorked</vs-th>
                    <vs-th>Tardiness</vs-th>
                    <vs-th>Absences</vs-th>
                    <vs-th>Undertime</vs-th>
                    <vs-th>Unpaid Leave Hours</vs-th>
                    <vs-th>Hourly Rate</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].user.employeeCode">
                            {{ data[indextr].user.employeeCode }}
                        </vs-td>
                        <vs-td :data="data[indextr].user.fullName">
                            {{ data[indextr].user.fullName }}
                        </vs-td>
                        <vs-td :data="data[indextr].basicpay">
                            {{ data[indextr].basicpay }}
                        </vs-td>
                        <vs-td :data="data[indextr].hoursWorked">
                            {{data[indextr].hoursWorked}}
                        </vs-td>
                        <vs-td :data="data[indextr].tardinessHours">
                            {{data[indextr].tardinessHours}}
                        </vs-td>
                        <vs-td :data="data[indextr].absencesHours">
                            {{data[indextr].absencesHours}}
                        </vs-td>
                        <vs-td :data="data[indextr].undertimeHours">
                            {{data[indextr].undertimeHours}}
                        </vs-td>
                        <vs-td :data="data[indextr].lwopHours">
                            {{data[indextr].lwopHours}}
                        </vs-td>
                        <vs-td :data="data[indextr].hourlyRate">
                            {{data[indextr].hourlyRate}}
                        </vs-td>
                        <vs-td>
                            <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onDeleteRecord(data[indextr].id)" />
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            </vx-card>
        </vs-tab>
         <vs-tab label="Overtime" icon-pack="feather" icon="icon-clock">
            <vx-card>
                <vs-table stripe pagination :max-items="10" search :data="getAllOvertimeHours" >
                    <template slot="thead">
                        <vs-th>Code</vs-th>
                        <vs-th>Name</vs-th>
                        <vs-th>Overtime Type</vs-th>
                        <vs-th>Overtime Hours</vs-th>
                        <vs-th>OT Rate</vs-th>
                        <vs-th>NSD Rate</vs-th>
                        <vs-th>Hourly Rate</vs-th>
                        <vs-th>Actions</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].user.employeeCode">
                                {{ data[indextr].user.employeeCode }}
                            </vs-td>
                            <vs-td :data="data[indextr].user.fullName">
                                {{ data[indextr].user.fullName }}
                            </vs-td>
                            <vs-td :data="data[indextr].overtimeTypeId">
                                {{ overtimeTypeName(data[indextr].overtimeTypeId).overtimeTypeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].overtimeHours">
                                {{data[indextr].overtimeHours}}
                            </vs-td>
                            <vs-td :data="data[indextr].otRate">
                                {{data[indextr].otRate}}
                            </vs-td>
                            <vs-td :data="data[indextr].nsdRate">
                                {{data[indextr].nsdRate}}
                            </vs-td>
                            <vs-td :data="data[indextr].hourlyRate">
                                {{data[indextr].hourlyRate}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vx-card>
        </vs-tab>
       <vs-tab label="Earnings" icon-pack="feather" icon="icon-plus">
            <vx-card>
            <vs-table stripe pagination :max-items="10" search :data="getAllEarnings"  >
                <template slot="thead">
                    <vs-th>Code</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th>Earnings Type</vs-th>
                    <vs-th>Amount</vs-th>
                    <vs-th>Hold?</vs-th>
                    <vs-th>Resume Date</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].user.employeeCode">
                            {{ data[indextr].user.employeeCode }}
                        </vs-td>
                        <vs-td :data="data[indextr].user.fullName">
                            {{ data[indextr].user.fullName }}
                        </vs-td>
                        <vs-td :data="data[indextr].earningsTypeId">
                            {{ data[indextr].earningsType.earningsTypeName }}
                        </vs-td>
                        <vs-td :data="data[indextr].earningsAmount">
                            {{ data[indextr].earningsAmount }}
                        </vs-td>
                        <vs-td :data="data[indextr].isHold">
                            <vs-checkbox v-model="data[indextr].isHold" :disabled="true"/>
                        </vs-td>
                        <vs-td :data="data[indextr].resumeDate">
                            {{ data[indextr].resumeDate | fulldate}}
                        </vs-td>
                        <vs-td>
                            <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onDeleteRecord(data[indextr].id)" />
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            </vx-card>
        </vs-tab>
       <vs-tab label="Deductions" icon-pack="feather" icon="icon-minus">
            <vx-card>
            <vs-table stripe pagination :max-items="10" search :data="getAllDeductions"   >
                <template slot="thead">
                    <vs-th>Code</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th>Deductions Type</vs-th>
                    <vs-th>Amount</vs-th>
                    <vs-th>Hold?</vs-th>
                    <vs-th>Resume Date</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].user.employeeCode">
                            {{ data[indextr].user.employeeCode }}
                        </vs-td>
                        <vs-td :data="data[indextr].user.fullName">
                            {{ data[indextr].user.fullName }}
                        </vs-td>
                        <vs-td :data="data[indextr].deductionsTypeId">
                            {{data[indextr].deductionsType.deductionsTypeName}}
                        </vs-td>
                        <vs-td :data="data[indextr].deductionsAmount">
                            {{data[indextr].deductionsAmount}}
                        </vs-td>
                        <vs-td :data="data[indextr].isHold">
                            <vs-checkbox v-model="data[indextr].isHold" :disabled="true"/>
                        </vs-td>
                        <vs-td :data="data[indextr].resumeDate">
                            {{ data[indextr].resumeDate | fulldate}}
                        </vs-td>
                        <vs-td>
                            <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onDeleteRecord(data[indextr].id)" />
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            </vx-card>
        </vs-tab>
        <vs-tab label="Loans" icon-pack="feather" icon="icon-credit-card">
            <vx-card>
            <vs-table stripe pagination :max-items="10" search :data="getAllLoans"   >
                <template slot="thead">
                    <vs-th>Code</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th>Loan Type</vs-th>
                    <vs-th>Loan Name</vs-th>
                    <vs-th>Amortization Amount</vs-th>
                    <vs-th>Hold?</vs-th>
                    <vs-th>Resume Date</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].user.employeeCode">
                            {{ data[indextr].user.employeeCode }}
                        </vs-td>
                        <vs-td :data="data[indextr].user.fullName">
                            {{ data[indextr].user.fullName }}
                        </vs-td>
                        <vs-td :data="data[indextr].loanCategoryId">
                            {{data[indextr].loanCategory.loanCategoryName}}
                        </vs-td>
                        <vs-td :data="data[indextr].loanNameId">
                            {{data[indextr].loanSubCategory.loanSubCategoryName}}
                        </vs-td>
                        <vs-td :data="data[indextr].amortizationAmount">
                            {{data[indextr].amortizationAmount}}
                        </vs-td>
                            <vs-td :data="data[indextr].isHold">
                            <vs-checkbox v-model="data[indextr].isHold" :disabled="true"/>
                        </vs-td>
                        <vs-td :data="data[indextr].resumeDate">
                            {{ data[indextr].resumeDate | fulldate}}
                        </vs-td>
                        <vs-td>
                            <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onDeleteRecord(data[indextr].id)" />
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            </vx-card>
        </vs-tab>
    </vs-tabs>

    <!-- EDIT LOG HOURS -->
              <vs-prompt
                  class="email-compose"
                  :title="promptTitle"
                  accept-text= "Submit"
                  @accept="onUpdateRecord"
                  :is-valid="validForm"
                  :active.sync="activePromptEditRecord">
                  <vx-card title="You may update the following information">

                  <div class="vx-row mb-3">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Code : </span>
                          <!-- <vs-input name="code" class="w-full" v-model="code"  :disabled="true"   /> -->
                          <b>{{code}}</b>
                      </div>
                  </div>
                  <div class="vx-row mb-3">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Name : </span>
                          <!-- <vs-input name="fullName"  class="w-full" v-model="fullName" :disabled="true" /> -->
                          <b>{{fullName}}</b>
                      </div>
                  </div>
                  <!-- activeTab 0 -->
                  <div class="vx-row mb-3" v-show="activeTab == 0">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Hours Worked</span><span style="color:red">*</span>
                          <vs-input name="hours worked" v-validate="'numeric|max_value:24'" class="w-full" v-model="hoursWorked"    />
                          <span class="text-danger text-sm" v-show="errors.has('hours worked')">{{ errors.first('hours worked') }}</span>

                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 0">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Tardiness</span><span style="color:red">*</span>
                          <vs-input name="tardiness hours" v-validate="'numeric|max_value:24'" class="w-full" v-model="tardinessHours"    />
                          <span class="text-danger text-sm" v-show="errors.has('tardiness hours')">{{ errors.first('tardiness hours') }}</span>

                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 0">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Absences</span><span style="color:red">*</span>
                          <vs-input name="absences hours" v-validate="'numeric|max_value:24'" class="w-full" v-model="absencesHours"    />
                          <span class="text-danger text-sm" v-show="errors.has('absences hours')">{{ errors.first('absences hours') }}</span>

                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 0">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Undertime</span><span style="color:red">*</span>
                          <vs-input name="undertime hours" v-validate="'numeric|max_value:24'" class="w-full" v-model="undertimeHours"    />
                          <span class="text-danger text-sm" v-show="errors.has('undertime hours')">{{ errors.first('undertime hours') }}</span>

                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 0">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Unpaid Leave Hours</span><span style="color:red">*</span>
                          <vs-input name="lwop hours" v-validate="'numeric|max_value:24'" class="w-full" v-model="lwopHours"    />
                          <span class="text-danger text-sm" v-show="errors.has('lwop hours')">{{ errors.first('lwop hours') }}</span>

                      </div>
                  </div>

                  <!-- activeTab 1 -->
                  <div class="vx-row mb-3" v-show="activeTab == 1">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Overtime Type</span><span style="color:red">*</span>
                          <v-select name="overtimeType-name" v-model="overtimeType" label="overtimeTypeName" :options="getOvertimeTypes"/>
                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 1">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Overtime Hours</span><span style="color:red">*</span>
                          <vs-input name="overtime hours" v-validate="'numeric|max_value:24'" class="w-full" v-model="overtimeHours"    />
                          <span class="text-danger text-sm" v-show="errors.has('overtime hours')">{{ errors.first('ovetime hours') }}</span>

                      </div>
                  </div>
                  <!-- activeTab 2 -->
                  <div class="vx-row mb-3" v-show="activeTab == 2">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Earnings Type : </span>
                          <b>{{earningsType.earningsTypeName}}</b>
                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 2">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Amount :</span>
                          <b>{{earningsAmount}}</b>
                      </div>
                  </div>
                  <!-- activeTab 3 -->
                  <div class="vx-row mb-3" v-show="activeTab == 3">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Deductions Type : </span>
                          <b>{{deductionsType.deductionsTypeName}}</b>
                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 3">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                          <span  class="text-sm">Amount :</span>
                          <b>{{deductionsAmount}}</b>
                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 2 || activeTab == 3 || activeTab == 4">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                      <div class="flex">
                          <span  class="text-sm">Hold? :</span>
                      <!-- </div>
                      <div class="vx-col sm:w-1/6 md:w-1/6 lg:w-1/6 xl:w-1/6 w-full mb-2"> -->
                          <vs-checkbox v-model="isHold"   />
                      </div>
                      </div>
                  </div>
                  <div class="vx-row mb-3" v-show="activeTab == 2 || activeTab == 3 || activeTab == 4">
                      <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span class="text-sm">Date Resume :</span>
                        <datepicker  v-model="resumeDate" />
                      </div>
                  </div>

                  </vx-card>
              </vs-prompt>
    <!-- END EDIT LOG HOURS -->
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    props: {
        createPayroll: {
            type: Object,
            required: false
        },
        isValidate3: {
            type: Boolean,
            required: false
        },
        // logHours: {
        //     type: Array,
        //     required: false
        // },
        // overtimeHours: {
        //     type: Array,
        //     required: false
        // }
    },
    data() {
        return {
            activeTab               : 0,
            activePromptEditRecord : false,
            promptTitle            : '',

            code                    :'',
            fullName                :'',

            // loghours
            logHoursId              :0,
            basicpay                :0,
            hoursWorked             :0,
            tardinessHours          :0,
            absencesHours           :0,
            undertimeHours          :0,
            lwopHours               :0,
            efficiencyRate          :0,
            isManuallyAdded         : false,
            addedManuallyOn         : null,
            addedManuallyBy         : '',
            uploadedOn              : null,
            uploadedBy              : '',
            extractedOn             : null,
            extractedBy             : '',
            userIdEdited            : 0,
            // overtime
            overtimeId              : 0,
            overtimeType            : [],
            overtimeHours           : 0,
            otRate                  : 0,
            nsdRate                 : 0,
            hourlyRate              : 0,
            //earnings

            earningsId              : 0,
            earningsType            : [],
            earningsAmount          : 0,
            isOneTime               : false,
            periodId                : 0,
            isHold                  : false,
            resumeDate              : null,
            effectivityDate         : null,
            expirationDate          : null,
            isActive                : false,
            dateDeactivated         : null,
            dateReActivated         : null,
            //deductions
            deductionsId            : 0,
            deductionsType          : [],
            deductionsAmount        : 0,
            //loans
            loansId                 : 0,
            refNumber               : 0,
            loanCategory            : [],
            loanSubCategory         : [],
            loanDate                : 0,
            principalAmount         : 0,
            withInterest            : 0,
            beginningBalance        : 0,
            amortizationAmount      : 0,
            loanStatus              : [],


        }
    },
    created() {
        this.$store.dispatch('lookup/getAllOvertimeType').catch((err) => { console.log(err) })
    },
    computed: {
        getAllLogHours: {
            get() { return this.$store.state.payroll.getAllLogHours },
            set(val) { return this.$store.dispatch('payroll/getAllLogHoursByPayrollId', val).catch((err) => { console.log(err) }) }
        },
        getAllOvertimeHours: {
            get() { return this.$store.state.payroll.getAllOvertime },
            set(val) { this.$store.dispatch('payroll/getAllOvertimeByPayrollId', val).catch((err) => { console.log(err) }) }
        },
        getAllEarnings : {
            get () { return this.$store.state.payroll.getAllEarnings },
            set(val) { this.$store.dispatch('payroll/getAllEarnings').catch((err) => { console.log(err) })}
        },
        getAllDeductions: {
            get() { return this.$store.state.payroll.getAllDeductions },
            set(val) { this.$store.dispatch('payroll/getAllDeductions').catch((err) => { console.log(err) }) }
        },
        getAllLoans: {
            get() { return this.$store.state.payroll.getAllLoans },
            set(val) { this.$store.dispatch('payroll/getAllLoans').catch((err) => { console.log(err) }) }
        },
        getSelectedEmployees() {
            return this.$store.state.selectedEmployees
        },
        getOvertimeTypes() {
            return this.$store.state.lookup.overtimeTypes
        },
        overtimeTypeName(){
            return (id) => this.$store.getters['lookup/overtimeType'](id)
        },
        validForm() {

        },
    },
    watch: {
        isValidate3(value) {
            if(value)
            this.onProcessTempToLive()
        }
    },
    methods: {
        onProcessTempToLive() {
            let selectedData = []

            let se = this.getSelectedEmployees

            se.forEach(u => {
                const tData = this.$store.getters['payroll/getUploadedLogHoursByEmpCode'](u.employeeCode)
                // console.log('tData')
                // console.log(tData)

                const edata = {
                    code: u.employeeCode,
                    hoursWorked: tData != null ? tData.hoursWorked : 0,
                    tardinessHours: tData!= null ? tData.tardinessHours : 0,
                    absencesHours: tData != null ? tData.absencesHours : 0,
                    undertimeHours: tData != null ? tData.undertimeHours : 0,
                    lwopHours: tData != null ? tData.lwopHours : 0,
                    createPayrollId: this.createPayroll.createPayrollId
                }
                selectedData.push(edata)
                // console.log('selectedData')
                // console.log(selectedData)
            })

            const lh = {
                data: selectedData,
                createPayrollId: this.createPayroll.createPayrollId,
                userId: this.$store.state.AppActiveUser.uid
            }
            this.$store.dispatch('payroll/AddUploadedLogHours', lh)
            .then(() => {
                const data = {
                    payrollId: this.createPayroll.createPayrollId,
                    paymentModeId: this.createPayroll.paymentModeId,
                    empStatusId: 0,
                    processedBy: this.$store.state.AppActiveUser.uid
                }
                this.$vs.loading()
                this.$store.dispatch('payroll/ProcessUploadedData', data)
                    .then(() => {
                        this.$vs.loading.close()
                        this.getAllLogHours = this.createPayroll.createPayrollId
                        this.getAllOvertimeHours = this.createPayroll.createPayrollId
                    })
                    .catch((err) => {
                        this.$vs.loading.close()
                        console.log(err)
                    })
            })




        },
        editRecord(id) {
            //console.log(this.activeTab)
            switch(this.activeTab) {
                case 0:
                    this.promptTitle = "Edit Log Hours"
                    const lh = this.$store.getters['payroll/getLogHoursById'](id)
                    this.logHoursId = lh.id,
                    this.code = lh.user.employeeCode,
                    this.fullName = lh.user.fullName,
                    this.basicpay = lh.basicpay,
                    this.hoursWorked = lh.hoursWorked
                    this.tardinessHours = lh.tardinessHours,
                    this.absencesHours = lh.absencesHours,
                    this.undertimeHours = lh.undertimeHours,
                    this.lwopHours = lh.lwopHours,
                    this.efficiencyRate = lh.efficiencyRate,
                    this.isManuallyAdded = lh.isManuallyAdded,
                    this.addedManuallyOn = lh.addedManuallyOn,
                    this.addedManuallyBy = lh.addedManuallyBy,
                    this.uploadedOn = lh.uploadedOn,
                    this.uploadedBy = lh.uploadedBy,
                    this.extractedOn = lh.extractedOn,
                    this.extractedBy = lh.extractedBy
                    this.userIdEdited = lh.userId
                    break;
                case 1:
                    this.promptTitle = "Edit Overtime Hours"
                    const o = this.$store.getters['payroll/getOvertimeById'](id)
                    this.overtimeId = o.id,
                    this.code = o.user.employeeCode,
                    this.fullName = o.user.fullName,
                    this.overtimeType = o.overtimeType
                    this.overtimeHours = o.overtimeHours
                    this.otRate = o.otRate,
                    this.nsdRate = o.nsdRate,
                    this.hourlyRate = o.hourlyRate,
                    this.isManuallyAdded = o.isManuallyAdded,
                    this.addedManuallyOn = o.addedManuallyOn,
                    this.addedManuallyBy = o.addedManuallyBy,
                    this.uploadedOn = o.uploadedOn,
                    this.uploadedBy = o.uploadedBy,
                    this.extractedOn = o.extractedOn,
                    this.extractedBy = o.extractedBy
                    this.userIdEdited = o.userId
                    break;
                case 2:
                    this.promptTitle = "Edit Earnings"

                    const e = this.$store.getters['payroll/getEarningsById'](id)
                    //console.log(e)
                    this.earningsId = e.id
                    this.code = e.user.employeeCode,
                    this.fullName = e.user.fullName,
                    this.earningsType = e.earningsType, //this.earningsTypeName(e.earningsTypeId).earningsTypeName,
                    this.earningsAmount = e.earningsAmount,
                    this.isOneTime = e.isOneTime,
                    this.periodId = e.periodId,
                    this.isHold = e.isHold,
                    this.resumeDate = e.resumeDate,
                    this.effectivityDate = e.effectivityDate,
                    this.expirationDate = e.expirationDate,
                    this.isActive = e.isActive,
                    this.dateDeactivated = e.dateDeactivated,
                    this.dateReActivated = e.dateReActivated,
                    this.userIdEdited = e.userId
                    break;
                case 3:
                    this.promptTitle = "Edit Deductions"
                    const d = this.$store.getters['payroll/getDeductionsById'](id)
                    this.deductionsId = d.id
                    this.code = d.user.employeeCode,
                    this.fullName = d.user.fullName,
                    this.deductionsType = d.deductionsType,
                    this.deductionsAmount = d.deductionsAmount,
                    this.isOneTime = d.isOneTime,
                    this.periodId = d.periodId,
                    this.isHold = d.isHold,
                    this.resumeDate = d.resumeDate,
                    this.effectivityDate = d.effectivityDate,
                    this.expirationDate = d.expirationDate,
                    this.isActive = d.isActive,
                    this.dateDeactivated = d.dateDeactivated,
                    this.dateReActivated = d.dateReActivated,
                    this.userIdEdited = d.userId
                    break;
                case 4:
                    this.promptTitle = "Edit Loans"
                    const l = this.$store.getters['payroll/getLoansById'](id)
                    //console.log(l)
                    this.loansId = l.id,
                    this.code = l.user.employeeCode,
                    this.fullName = l.user.fullName,
                    this.refNumber = l.referenceNumber,
                    this.loanCategory = l.loanCategory,
                    this.loanSubCategory = l.loanSubCategory,
                    this.periodId = l.periodId,
                    this.loanDate = l.loanDate,
                    this.principalAmount = l.principalAmount,
                    this.withInterest = l.withInterest,
                    this.beginningBalance = l.beginningBalance,
                    this.amortizationAmount = l.amortizationAmount,
                    this.loanStatus = l.loanStatus,
                    this.isHold = l.isHold,
                    this.isActive = l.isActive,
                    this.resumeDate = l.resumeDate,
                    this.effectivityDate = l.effectivityDate,
                    this.expirationDate = l.expirationDate,
                    this.dateDeactivated = l.dateDeactivated,
                    this.dateReActivated = l.dateReActivated,
                    this.userIdEdited = l.userId
                    break;
            }



            this.activePromptEditRecord = true
    },
    onDeleteRecord(id) {
      switch(this.activeTab) {
            case 0:
              this.$store.dispatch('payroll/DeleteEmployeeLogHours', id)
              break;
            case 1:
              this.$store.dispatch('payroll/DeleteEmployeeOvertime', id)
              break;
            case 2:
              this.$store.dispatch('payroll/DeleteEmployeeEarnings', id)
              break;
            case 3:
              this.$store.dispatch('payroll/DeleteEmployeeDeductions', id)
              break;
            case 4:
              this.$store.dispatch('payroll/DeleteEmployeeLoans', id)
              break;
      }
    },
    onUpdateRecord() {
        switch(this.activeTab) {
            case 0:
                const lh = {
                    id                      : this.logHoursId,
                    basicpay                : this.basicpay,
                    hoursWorked             : this.hoursWorked,
                    tardinessHours          : this.tardinessHours,
                    absencesHours           : this.absencesHours,
                    undertimeHours          : this.undertimeHours,
                    lwopHours               : this.lwopHours,
                    efficiencyRate          : this.efficiencyRate,
                    isManuallyAdded         : this.isManuallyAdded,
                    addedManuallyOn         : this.addedManuallyOn,
                    addedManuallyBy         : this.addedManuallyBy,
                    uploadedOn              : this.uploadedOn,
                    uploadedBy              : this.uploadedBy,
                    extractedOn             : this.extractedOn,
                    extractedBy             : this.extractedBy,
                    createPayrollId         : this.createPayroll.createPayrollId,
                    userId                  : this.userIdEdited,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }

                // console.log(lh)
                this.$store.dispatch('payroll/UpdateEmployeeLogHours', lh)
                .then(() => {
                    // this.getAllLogHours = this.createPayroll.createPayrollId
                })
                break;
            case 1:
                const o = {
                    overtimeTypeId          : this.overtimeType.overtimeTypeId,
                    overtimeHours           : this.overtimeHours,
                    otRate                  : this.otRate,
                    nsdRate                 : this.nsdRate,
                    hourlyRate              : this.hourlyRate,
                    isManuallyAdded         : this.isManuallyAdded,
                    addedManuallyOn         : this.addedManuallyOn,
                    addedManuallyBy         : this.addedManuallyBy,
                    uploadedOn              : this.uploadedOn,
                    uploadedBy              : this.uploadedBy,
                    extractedOn             : this.extractedOn,
                    extractedBy             : this.extractedBy,
                    createPayrollId         : this.createPayroll.createPayrollId,
                    userId                  : this.userIdEdited,
                    id                      : this.overtimeId,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
            this.$store.dispatch('payroll/UpdateEmployeeOvertime', o)
                .then(() => {
                })
                break;
            case 2:
                const e = {
                    earningsTypeId          : this.earningsType.earningsTypeId,
                    earningsAmount          : this.earningsAmount,
                    isOneTime               : this.isOneTime,
                    periodId                : this.periodId,
                    isHold                  : this.isHold,
                    resumeDate              : this.isHold ? this.resumeDate : null,
                    effectivityDate         : this.effectivityDate,
                    expirationDate          : this.expirationDate,
                    isActive                : this.isActive,
                    dateDeactivated         : this.dateDeactivated ,
                    dateReActivated         : this.dateReActivated ,
                    userId                  : this.userIdEdited,
                    id                      : this.earningsId,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
            this.$store.dispatch('payroll/UpdateEmployeeEarnings', e)
                .then((res) => {
                })
                break;
            case 3:
                const d = {
                    deductionsTypeId        : this.deductionsType.deductionsTypeId,
                    deductionsAmount        : this.deductionsAmount,
                    isOneTime               : this.isOneTime,
                    periodId                : this.periodId,
                    isHold                  : this.isHold,
                    resumeDate              : this.isHold ? this.resumeDate : null,
                    effectivityDate         : this.effectivityDate,
                    expirationDate          : this.expirationDate,
                    isActive                : this.isActive,
                    dateDeactivated         : this.dateDeactivated ,
                    dateReActivated         : this.dateReActivated ,
                    userId                  : this.userIdEdited,
                    id                      : this.deductionsId,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
            this.$store.dispatch('payroll/UpdateEmployeeDeductions', d)
                .then((res) => {
                })
                break;
            case 4:
                const l = {
                    referenceNumber         : this.refNumber,
                    loanCategoryId          : this.loanCategory.loanCategoryId,
                    loanSubCategoryId       : this.loanSubCategory.loanSubCategoryId,
                    periodId                : this.periodId,
                    loanDate                : this.loanDate,
                    principalAmount         : this.principalAmount,
                    withInterest            : this.withInterest,
                    beginningBalance        : this.beginningBalance,
                    amortizationAmount      : this.amortizationAmount,
                    loanStatus              : this.loanStatus,
                    isHold                  : this.isHold,
                    resumeDate              : this.isHold ? this.resumeDate : null,
                    effectivityDate         : this.effectivityDate,
                    expirationDate          : this.expirationDate,
                    isActive                : this.isActive,
                    dateDeactivated         : this.dateDeactivated ,
                    dateReActivated         : this.dateReActivated ,
                    userId                  : this.userIdEdited,
                    id                      : this.loansId,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('payroll/UpdateEmployeeLoans', l)
                .then((res) => {
                })
                break;
            }
        },

    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
    }
}
</script>
